// extracted by mini-css-extract-plugin
export default {"mainContent":"Template_mainContent__5kpbD"};